import React, {Fragment, memo, useCallback} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';

import NavCloseIcon from '../images/nav_close.svg';
import NavOpenIcon from '../images/nav_open.svg';
import {useDispatch, useSelector} from '../store';

import {styleMods} from '../utils';

import style from './header.module.scss';
import LocaleLink from './locale-link';

export default memo(
	function Header() {
		const navOpen = useSelector((s) => s.navOpen);
		const dispatch = useDispatch();

		const intl = useIntl();

		const toggleNav = useCallback(
			() => {
				dispatch(navOpen ? {type: 'closeNav'} : {type: 'openNav'});
			},
			[navOpen, dispatch],
		);

		return (
			<Fragment>
				<div className={style.placeholder} />
				<div className={style.bg}>
					<header className={style.base}>
						<LocaleLink
							to="/"
							title={intl.formatMessage({id: 'nav.home'})}
							className={style.homeLink}
						>
							<div className={style.siteHeadline}>
								<FormattedMessage id="site.headline" />
							</div>

							<div className={style.siteIcon}>
								LICHT<br />
								PARCOURS<br />
								2020
							</div>
						</LocaleLink>

						<button
							className={style.navButton}
							onClick={toggleNav}
						>
							<NavOpenIcon
								className={styleMods(style, 'navButtonIcon', {
									visible: !navOpen,
								})}
							/>

							<NavCloseIcon
								className={styleMods(style, 'navButtonIcon', {
									visible: navOpen,
								})}
							/>
						</button>
					</header>
				</div>
			</Fragment>
		);
	}
);
